import en from './en.json';
import de from './de.json';
import ko from './ko.json';
import fa from './fa.json';
import ar from './ar.json';
import fr from './fr.json';
import es from './es.json';
import ja from './ja.json';
import vi from './vi.json';
import id from './id.json';
import zh from './zh.json';
import pt from './pt.json';
import tr from './tr.json';
import mn from './mn.json';
import ur from './ur.json';
import it from './it.json';
import ru from './ru.json';
import nl from './nl.json';

export default {
	en,
	de,
	ko,
	ja,
	fa,
	ar,
	fr,
	es,
	pt,
	vi,
	id,
	zh,
	tr,
	mn,
	ur,
	it,
	ru,
	nl,
};
